import { render, staticRenderFns } from "./DrawerAppointmentsTab.vue?vue&type=template&id=291c97ff&scoped=true"
import script from "./DrawerAppointmentsTab.vue?vue&type=script&lang=js"
export * from "./DrawerAppointmentsTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerAppointmentsTab.vue?vue&type=style&index=0&id=291c97ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291c97ff",
  null
  
)

export default component.exports